import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/expand_more.svg'


const _hoisted_1 = { class: "small-text" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClickout: _cache[1] || (_cache[1] = ($event: any) => (this.hideDropdown = true))
  }, [
    _createElementVNode("div", {
      class: "project-color-selector small-text",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showColorDropdown()))
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("local-task-component-locales.project-color")), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["selected-color-display", [_ctx.selectedColorName]])
      }, null, 2),
      _hoisted_2
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["project-colors-block", { hideElement: _ctx.hideDropdown }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectColors, (projectColor, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "project-color-wrapper"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass({ 'selected-color': _ctx.selectedColorName === projectColor })
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["project-color", projectColor]),
              onClick: ($event: any) => (_ctx.selectColor(projectColor))
            }, null, 10, _hoisted_3)
          ], 2)
        ]))
      }), 128))
    ], 2)
  ], 32))
}